import React from 'react';
import ScrollView from 'devextreme-react/scroll-view';
import './single-card.scss';

export default function SingleCard({ title, description, children }) {
  return (
    <>
      <div className="headerLogin">
        <div className="inner">
          <div className="logo">
            <img src={window.location.origin + "/LogoTouchSoft.png"}  alt="Logo"/>
          </div>
          <div className="name">
            <span>
              Touch Soft Rapport
            </span>
          </div>          
        </div>
      </div>      
      <ScrollView showScrollbar='never' className={'with-footer single-card login-box'}>
        <div className={'dx-card content'}>
          <div className={'header'}>
            <div className={'title'}>{title}</div>
            <div className={'description'}>{description}</div>
          </div>
          {children}
        </div>
      </ScrollView></>
  )
}
